import { Sun, Moon } from "lucide-react";
import { useState, useEffect } from "react";
import { LOCAL_STORAGE_KEYS, setLocalStorage, getLocalStorage } from "../utils/localStorageUtil";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { applyTheme } from "../utils/utility";

export default function ThemeToggle() {
  const [theme, setTheme] = useState(getLocalStorage(LOCAL_STORAGE_KEYS.THEME, false) || "light");

  useEffect(() => {
    applyTheme(theme);
    setLocalStorage(LOCAL_STORAGE_KEYS.THEME, theme);
  }, [theme]);

  return (
    <div className="flex items-center gap-8 font-medium rounded-md cursor-pointer">
      <span>Theme</span>
      <ToggleButtonGroup
        value={theme}
        exclusive
        onChange={(event, newTheme) => {
          if (newTheme !== null) setTheme(newTheme);
        }}
        size="small"
        sx={{
          bgcolor: "lightgray",
        }}
      >
        <ToggleButton value="light">
          <Sun size={18} />
        </ToggleButton>
        <ToggleButton value="dark">
          <Moon size={18} />
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
}
